var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 79.5,
    stroke: "#364957",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 79.2001C44 65.6237 44 58.8355 48.2177 54.6178C52.4353 50.4001 59.2235 50.4001 72.8 50.4001H87.2C100.776 50.4001 107.565 50.4001 111.782 54.6178C116 58.8355 116 65.6237 116 79.2001V86.4001C116 99.9765 116 106.765 111.782 110.982C107.565 115.2 100.776 115.2 87.2 115.2H72.8C59.2235 115.2 52.4353 115.2 48.2177 110.982C44 106.765 44 99.9765 44 86.4001V79.2001Z",
    stroke: "#6B7280",
    strokeWidth: 5.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0001 50.4V45",
    stroke: "#6B7280",
    strokeWidth: 5.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0001 50.4V45",
    stroke: "#6B7280",
    strokeWidth: 5.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 68.4001H114.2",
    stroke: "#6B7280",
    strokeWidth: 5.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.6 97.1999C101.6 99.1881 99.9883 100.8 98 100.8C96.0117 100.8 94.4 99.1881 94.4 97.1999C94.4 95.2116 96.0117 93.5999 98 93.5999C99.9883 93.5999 101.6 95.2116 101.6 97.1999Z",
    fill: "#6B7280"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.6 82.7997C101.6 84.788 99.9883 86.3997 98 86.3997C96.0117 86.3997 94.4 84.788 94.4 82.7997C94.4 80.8114 96.0117 79.1997 98 79.1997C99.9883 79.1997 101.6 80.8114 101.6 82.7997Z",
    fill: "#6B7280"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 97.1999C83.6 99.1881 81.9883 100.8 80 100.8C78.0117 100.8 76.4 99.1881 76.4 97.1999C76.4 95.2116 78.0117 93.5999 80 93.5999C81.9883 93.5999 83.6 95.2116 83.6 97.1999Z",
    fill: "#6B7280"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 82.7997C83.6 84.788 81.9883 86.3997 80 86.3997C78.0117 86.3997 76.4 84.788 76.4 82.7997C76.4 80.8114 78.0117 79.1997 80 79.1997C81.9883 79.1997 83.6 80.8114 83.6 82.7997Z",
    fill: "#6B7280"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6 97.1999C65.6 99.1881 63.9882 100.8 62 100.8C60.0118 100.8 58.4 99.1881 58.4 97.1999C58.4 95.2116 60.0118 93.5999 62 93.5999C63.9882 93.5999 65.6 95.2116 65.6 97.1999Z",
    fill: "#6B7280"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6 82.7997C65.6 84.788 63.9882 86.3997 62 86.3997C60.0118 86.3997 58.4 84.788 58.4 82.7997C58.4 80.8114 60.0118 79.1997 62 79.1997C63.9882 79.1997 65.6 80.8114 65.6 82.7997Z",
    fill: "#6B7280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.f5d2aaba1248b4ceba3c5c12d832fb4f.svg";
export { ForwardRef as ReactComponent };